const APAC_COUNTRIES: Record<string, string> = {
  AS: 'American Samoa',
  AQ: 'Antarctica',
  AU: 'Australia',
  BD: 'Bangladesh',
  BT: 'Bhutan',
  IO: 'British Indian Ocean Territory',
  BN: 'Brunei Darussalam',
  KH: 'Cambodia',
  CN: 'China',
  CX: 'Christmas Island',
  CC: 'Cocos (Keeling) Islands',
  CK: 'Cook Islands',
  FJ: 'Fiji',
  PF: 'French Polynesia',
  TF: 'French Southern Territories',
  GU: 'Guam',
  HM: 'Heard Island and McDonald Islands',
  HK: 'Hong Kong',
  IN: 'India',
  ID: 'Indonesia',
  JP: 'Japan',
  KI: 'Kiribati',
  KV: "Korea (Democratic People's Republic of)",
  KR: 'Korea (Republic of)',
  KG: 'Kyrgyzstan',
  LA: 'Laos',
  MO: 'Macao',
  MY: 'Malaysia',
  MV: 'Maldives',
  MH: 'Marshall Islands',
  FM: 'Micronesia',
  MN: 'Mongolia',
  MM: 'Myanmar',
  NR: 'Nauru',
  NP: 'Nepal',
  NC: 'New Caledonia',
  NZ: 'New Zealand',
  NU: 'Niue',
  NF: 'Norfolk Island',
  MP: 'Northern Mariana Islands',
  PK: 'Pakistan',
  PW: 'Palau',
  PG: 'Papua New Guinea',
  PH: 'Philippines',
  PN: 'Pitcairn',
  WS: 'Samoa',
  SG: 'Singapore',
  SB: 'Solomon Islands',
  LK: 'Sri Lanka',
  TW: 'Taiwan',
  TJ: 'Tajikistan',
  TH: 'Thailand',
  TL: 'Timor-Leste',
  TK: 'Tokelau',
  TO: 'Tonga',
  TM: 'Turkmenistan',
  TV: 'Tuvalu',
  UM: 'United States Minor Outlying Islands',
  UZ: 'Uzbekistan',
  VU: 'Vanuatu',
  VN: 'Viet Nam',
  WF: 'Wallis and Futuna',
};

export const isAPACCountry = (countryCode: string): boolean => {
  return countryCode in APAC_COUNTRIES;
};
